export const actionConst = {
    OPEN_NEW_REQUEST_MODAL: 'OPEN_NEW_REQUEST_MODAL',
    CLOSE_NEW_REQUEST_MODAL: 'CLOSE_NEW_REQUEST_MODAL',
    FETCH_ADDR_STREET_REF: 'FETCH_ADDR_STREET_REF', 
    FETCH_ADDR_SERVICE_COMPANY: 'FETCH_ADDR_SERVICE_COMPANY', 
    SET_APPLICANT: 'SET_APPLICANT',
    CLEAR_APPLICANT: 'CLEAR_APPLICANT',
    FETCH_CREATION_METHOD_REF: 'FETCH_CREATION_METHOD_REF',
    FETCH_SERVICE_REF: 'FETCH_SERVICE_REF', 
    FETCH_WORKER_REF: 'FETCH_WORKER_REF', 
    FETCH_EXECUTER_REF: 'FETCH_EXECUTER_REF', 
    APPLY_SERVICE: 'APPLY_SERVICE', 
    APPLY_POSS_WARRANTY: 'APPLY_POSS_WARRANTY', 
    APPLY_POSS_INTERNAL: 'APPLY_POSS_INTERNAL',
    APPLY_ADDR_STREET: 'APPLY_ADDR_STREET', 
    APPLY_ADDR_SERVICE_COMPANY: 'APPLY_ADDR_SERVICE_COMPANY', 
    FETCH_SUBSERVICE_REF: 'FETCH_SUBSERVICE_REF', 
    FETCH_APPLY_ADDRESS_BY_PHONE_REF: 'FETCH_APPLY_ADDRESS_BY_PHONE_REF',
    SET_SUBSERVICE_VALUE: 'SET_SUBSERVICE_VALUE', 
    SET_SERVICE_VALUE: 'SET_SERVICE_VALUE', 
    FETCH_ADDR_BUILDING_REF: 'FETCH_ADDR_BUILDING_REF', 
    FETCH_ADDR_FLAT_REF: 'FETCH_ADDR_FLAT_REF', 
    SET_ADDR_BUILDING_VALUE: 'SET_ADDR_BUILDING_VALUE', 
    SET_ADDR_FLAT_VALUE: 'SET_ADDR_FLAT_VALUE', 
    SET_WORKER_VALUE: 'SET_WORKER_VALUE', 
    SET_EXECUTER_VALUE: 'SET_EXECUTER_VALUE', 
    SET_SHOW_POSS_WARRANTY: 'SET_SHOW_POSS_WARRANTY', 
    POST_REQUEST: 'POST_REQUEST',
    RESET_POSTED_REQUEST: 'RESET_POSTED_REQUEST',
    SET_OWNER_DATA: 'SET_OWNER_DATA',
    SET_OWNER_INFO: 'SET_OWNER_INFO',
    SET_REQUEST_ID: 'SET_REQUEST_ID',
    SET_TERM_OF_EXECUTION: 'SET_TERM_OF_EXECUTION',
    RESET_TERM_OF_EXECUTION: 'RESET_TERM_OF_EXECUTION',
    RETRIEVE_LAST_STATE: 'RETRIEVE_LAST_STATE',
    SET_STAGE_LIFE: 'SET_STAGE_LIFE',
    CLEAR_STAGE_LIFE: 'CLEAR_STAGE_LIFE',
    SET_OLD_REQUESTS: 'SET_OLD_REQUESTS',
    CLEAR_OLD_REQUESTS: 'CLEAR_OLD_REQUESTS',
    SET_HINTS_BY_REQUEST_TYPE: 'SET_HINTS_BY_REQUEST_TYPE',
    CLEAR_HINTS_BY_REQUEST_TYPE: 'CLEAR_HINTS_BY_REQUEST_TYPE',
    SET_HINTS_BY_SERVICE_COMPANY: 'SET_HINTS_BY_SERVICE_COMPANY',
    CLEAR_HINTS_BY_SERVICE_COMPANY: 'SET_HINTS_BY_SERVICE_COMPANY',
    SET_SHOW_HINTS_AND_OLD_REQUESTS: 'SET_SHOW_HINTS_AND_OLD_REQUESTS'
};
